import React, { useState } from "react";
import { TextField, Button, Box, Typography, Grid } from "@mui/material";
import { ReactComponent as PlushIcon } from "../../assets/dashboardIcons/plusicon.svg";
import { ReactComponent as Wifi } from "../../assets/dashboardIcons/wifiIcon.svg";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import MenuWithPDF from "../filter/MenuWithPDF";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useSelector } from "react-redux";
import produzioniFormAPI from "../../services/produzioniFormApi";
dayjs.locale('it');

const TableInputPigiatura = ({ option, rows, setRows, activeStep }) => {
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const { control } = useForm();
    // const [rows, setRows] = useState([
    //     { id: 1, date: null, grapeWeight: "", raspiWeight: "", raspiPercentage: "", tempMosto: "", phMosto: "" },
    //     { id: 2, date: null, grapeWeight: "", raspiWeight: "", raspiPercentage: "", tempMosto: "", phMosto: "" },
    //     { id: 3, date: null, grapeWeight: "", raspiWeight: "", raspiPercentage: "", tempMosto: "", phMosto: "" },
    // ]);

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, date_of_pigiatura: null, qty_uva_lavorata: "", qty_raspi_rimossi: "", percent_raspi_rimossi: "", temp_mosto: "", ph_del_mosto: "" }
        ]);
    };

    const handleDelete = async (index) => {
        const row = rows[index];
    
        if (row.id) {
          try {
            await produzioniFormAPI.deleteStepFormRow({
                id: row.id, 
                formName: "pigiatura"
            });
          } catch (err) {
            console.error("Error deleting row from server:", err);
            return;
          }
        }

        setRows((prev) => prev.filter((_, i) => i !== index));
      };
    return (
        <Box className="tableInput" sx={{ maxWidth: "100%", padding: 2 }}>
            <h3 className="sectiontitleSmall">Pigiature e diraspature</h3>

            {/* Column Titles */}
            <Grid container spacing={1} sx={{ marginBottom: 1, fontWeight: "bold", color: "gray" }}>
                <Grid  size={.5}><Typography>ID</Typography></Grid>
                <Grid  size={2.2}><Typography>Data e ora pigiatura</Typography></Grid>
                <Grid  size={2.2}><Typography>Q.ta UVA lavorata (Kg)</Typography></Grid>
                <Grid  size={2.2}><Typography>Q.ta Raspi rimossi (Kg)</Typography></Grid>
                <Grid  size={1.7}><Typography>% Raspi rimossi</Typography></Grid>
                <Grid  size={1.6}>
                    <Box className="inputBoxIcon heading">
                        <p>Temp. mosto</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
                <Grid  size={1.5}>
                    <Box className="inputBoxIcon heading">
                        <p>PH del mosto</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
            </Grid>

            {/* Dynamic Rows */}
            {rows?.map((row, index) => (
                <>
                    <Grid container spacing={1} key={index} sx={{ marginBottom: 1 }}>
                        <Grid  size={.5}>
                            <TextField
                                className="customTextBox"
                                label="ID"
                                size="small"
                                value={row.id || index}
                                disabled
                            />
                        </Grid>

                        <Grid  size={2.2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                                <Controller
                                    name={`date-${index}`}
                                    control={control}
                                    render={({ field }) => (
                                        <DateTimePicker
                                            label="Data e ora pigiatura"
                                            value={row?.date_of_pigiatura ? dayjs(row.date_of_pigiatura) : null}
                                            className='datePickerField'
                                            onChange={(newValue) => {
                                                const formattedDateTime = dayjs(newValue).format("YYYY-MM-DD HH:mm:ss");
                                                handleInputChange(index, "date_of_pigiatura", formattedDateTime);
                                                field.onChange(formattedDateTime);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} fullWidth margin="normal" size="small" />
                                            )}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>

                        <Grid  size={2.2}>
                            <TextField
                                defaultValue=""
                                className="customTextBox"
                                label="Q.ta UVA lavorata (Kg)"
                                size="small"
                                onChange={(e) => handleInputChange(index, "qty_uva_lavorata", e.target.value)}
                                value={row.qty_uva_lavorata}
                            />
                        </Grid>

                        <Grid  size={2.2}>
                            <TextField
                            defaultValue=""
                                className="customTextBox"
                                label="Q.ta Raspi rimossi (Kg)"
                                size="small"
                                onChange={(e) => handleInputChange(index, "qty_raspi_rimossi", e.target.value)}
                                value={row.qty_raspi_rimossi}
                            />
                        </Grid>

                        <Grid  size={1.7}>
                            <TextField
                            defaultValue=""
                                className="customTextBox"
                                label="% Raspi rimossi"
                                size="small"
                                onChange={(e) => handleInputChange(index, "percent_raspi_rimossi", e.target.value)}
                                value={row.percent_raspi_rimossi}
                            />
                        </Grid>

                        <Grid  size={1.6}>
                            <Box className="inputBoxIcon">
                                <TextField
                                defaultValue=""
                                    className="customTextBox"
                                    label="Temp. mosto"
                                    onChange={(e) => handleInputChange(index, "temp_mosto", e.target.value)}
                                    size="small"
                                    value={row.temp_mosto}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>

                        <Grid  size={1.5}>
                            <Box className="inputBoxIcon">
                                <TextField
                                defaultValue="" 
                                    className="customTextBox"
                                    label="PH del mosto"
                                    onChange={(e) => handleInputChange(index, "ph_del_mosto", e.target.value)}
                                    size="small"
                                    value={row.ph_del_mosto}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>
                        <Grid  size={.1}>
                            <MenuWithPDF
                                options={option}
                                handleDelete={(event) => {
                                    event?.stopPropagation();
                                    handleDelete(index);
                                }}
                            />
                        </Grid>
                    </Grid>

                </>
            ))}

            {/* Add Button */}
            <Button
                variant="body2"
                onClick={addRow}
                sx={{
                    cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
                    fontFamily: '"Public Sans", sans-serif !important',
                    '&:hover': {
                        color: '#57C700',
                        background: "transparent"
                    }
                }}
            >
                <PlushIcon /> aggiungi pigiatura e diraspatura
            </Button>
        </Box>
    );
};

export default TableInputPigiatura;
